/* eslint-disable @nrwl/nx/enforce-module-boundaries */

import { Homepage } from '../../../libs/source/src/homepage/pages/Homepage';
import { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next';
import { initializeApollo, graphQLWrapper } from '@zoopla/apollo';
import { withSSROptimizely } from '@zoopla/optimizely';
import HOMEPAGE_QUERY from '../../../libs/source/src/homepage/queries/homepage.query';
import { HomepageQuery } from '../../../libs/source/src/homepage/queries/homepage.query.generated';
import {
    ArticlesForHomepageQuery,
    ArticlesForHomepageDocument
} from '../../../libs/source/src/homepage/queries/propertyNews.generated';
import { logInfo } from '@zoopla/logger';

export default graphQLWrapper(Homepage);

async function _getServerSideProps({ req, res }: GetServerSidePropsContext) {
    if (typeof window === 'undefined') {
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const newrelic = require('newrelic');
        newrelic.setTransactionName(`/`);
    }

    const apolloClient = initializeApollo(null, req.headers);

    // preconnect to the contenful image api as banner images make up page LCP
    res.setHeader('Link', [
        '<https://images.ctfassets.net>; rel="preconnect"',
        '<https://securepubads.g.doubleclick.net>; rel="preconnect"',
        '<https://scripts.prod.zoopla.co.uk>; rel="preconnect"',
        '<https://www.googletagmanager.com>; rel="preconnect"',
        '<https://gdpr.privacymanager.io>; rel="preconnect"',
        '<https://gdpr-wrapper.privacymanager.io>; rel="preconnect"'
    ]);

    try {
        const homepage = await apolloClient?.query<HomepageQuery>({
            query: HOMEPAGE_QUERY
        });
        const homepageData = homepage?.data?.homepage || {};

        const propertyNews =
            await apolloClient?.query<ArticlesForHomepageQuery>({
                query: ArticlesForHomepageDocument
            });

        return {
            props: {
                ...homepageData,
                propertyNewsArticles: propertyNews?.data?.articles
            }
        };
    } catch (error) {
        // TODO: handle logging
        logInfo('Homepage Contentful error: ', error);
        return {
            props: {}
        };
    }
}

type GSSP = InferGetServerSidePropsType<typeof _getServerSideProps>;

export const getServerSideProps =
    withSSROptimizely.getServerSideProps<GSSP>(_getServerSideProps);
